<template>
  <div>
    <h1 class="page-header">{{ $t('positionLevel.pageTitle') }}</h1>
    <ts-card>
      <ts-card-wrapper>
        <div class="row">
          <div class="col-sm-12 col-md-10">
            <ts-button color="info" outline @click="showForm()">
              {{ $t('addNew') }}
            </ts-button>
          </div>
          <div class="col-sm-12 col-md-2 d-flex justify-content-end">
            <ts-input v-model="search" :placeholder="$t('search')" />
          </div>
        </div>
      </ts-card-wrapper>
      <ts-table :columns="columns" :records="resources" :loading="loading">
        <template v-slot="{ record, index }">
          <td>{{ record.position_level_name_kh }}</td>
          <td>{{ record.position_level_name_en }}</td>
          <td class="text-center">{{ record.level_order }}</td>
          <td class="text-center">
            <a href="#" v-tooltip="'Edit'" class="text-primary mr-2" @click.prevent="edit(record)">
              <i class="fas fa-edit"></i>
            </a>
            <a
              href="#"
              v-tooltip="'Release'"
              class="text-danger"
              @click.prevent="destroy(record)"
              :disabled="record._deleting"
            >
              <i class="fas fa-circle-notch spin" v-if="record._deleting"></i>
              <i class="fa fa-trash" v-else></i>
            </a>
          </td>
        </template>
      </ts-table>
      <div class="d-flex justify-content-end p-15">
        <ts-pagination v-model="pagination" @navigate="fetchData"></ts-pagination>
      </div>
    </ts-card>
  </div>
</template>

<script>
import { debounce } from 'lodash'
import { mapState, mapGetters } from 'vuex'
import FormComponent from './form.vue'

export default {
  name: 'positionLevel',
  components: {
    FormComponent
  },
  data() {
    return {
      loading: false
    }
  },
  created() {
    this.fetchData()
  },
  computed: {
    ...mapState('hr/positionLevel', ['resources', 'pagination']),
    search: {
      get() {
        return this.$store.state.hr.positionLevel.search
      },
      set(newValue) {
        this.$store.commit('hr/positionLevel/SET_SEARCH', newValue)
        this.$store.commit('hr/positionLevel/RESET_CURRENT_PAGE')
      }
    },
    columns() {
      return [
        {
          name: this.$t('positionLevel.nameKh')
        },
        {
          name: this.$t('positionLevel.nameEn')
        },
        {
          name: this.$t('positionLevel.order'),
          style: 'text-align:center'
        },
        { name: this.$t('actions'), style: 'text-align:center; width: 7%;' }
      ]
    }
  },
  methods: {
    fetchData(attributes) {
      this.loading = true
      this.$store
        .dispatch('hr/positionLevel/fetch', attributes)
        .then(response => {
          this.loading = false
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
    },
    showForm(editData) {
      this.$modal.show(
        FormComponent,
        {
          editData: editData
        },
        {
          height: 'auto',
          width: '400px',
          scrollable: true,
          draggable: '.form-header',
          clickToClose: false
        }
      )
    },
    edit(record) {
      this.showForm(record)
    },
    async destroy(record) {
      if (await this.$confirmModal.danger(this.$t('are_you_sure_to_delete'))) {
        record._deleting = true
        this.$store
          .dispatch('hr/positionLevel/destroy', record.position_level_id)
          .then(response => {
            this.fetchData()
            this.$toasted.success(response.message)
            record._deleting = false
          })
          .catch(error => {
            this.$toasted.error(error.message)
            record._deleting = false
          })
      }
    }
  },
  watch: {
    search: debounce(function(search) {
      this.fetchData({ search })
    }, 500)
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit('hr/positionLevel/RESET_STATE')
    next()
  }
}
</script>
